import { useEffect, useState } from "react"
import { useCentralStore } from "../../../store/appContext"
import resources from '../../../components/common/resources.json'
import SLADataTable from "../../../components/common/dataTable/SLADataTable"

const CsSLADataTab2 = () => {

    const [{ slaReportCountSuccess }, dispatch] = useCentralStore()
    const Data = slaReportCountSuccess?.GetSLADetailsResponse?.CustomerServiceSLA

    const newData = Data.map(obj => {
        return Object.keys(obj)
            .filter(key => key !== 'ActualSLA%' && key !== 'ExpectedSLA%' && key !== 'Month')
            .reduce((acc, key) => {
                acc[key] = obj[key];
                return acc;
            }, {});
    });

    const [csSlaData, setCsSlaDta] = useState(null);

    useEffect(() => {
        if (slaReportCountSuccess) setCsSlaDta(newData)
    }, [slaReportCountSuccess])

    const [_label, setLabel] = useState(null);
    const [_index, setIndex] = useState(null);
    const [_metricsLabel, setMetricsLabel] = useState(null);

    return (
        <div className="flex text-black">

            <SLADataTable
                reportDetailsSuccess={csSlaData}
                resources={resources}
            />

        </div>
    )
}

export default CsSLADataTab2